export default "__VITE_ASSET__U8bX6Foo__"